import React from 'react';
import { Widget } from 'jamespot-front-business';
import { shallowEqual } from 'react-redux';
import styled from 'styled-components';
import { JRCHtml } from 'jamespot-react-components';
import { useAppSelector } from '../../../../redux/store';

export const CSSWidgetTitle = styled.div`
    padding: ${(props) => props.theme.space.md}px;
    border-bottom: 1px solid ${(props) => props.theme.color.grey1};
`;

export const WidgetTitle = ({ uniqid }: { uniqid: string }) => {
    const widgetWrapper = useAppSelector((state) => Widget.selectors.selectWidget(state, uniqid), shallowEqual);
    return (
        <>
            {widgetWrapper && typeof widgetWrapper.title === 'string' && widgetWrapper.title.length !== 0 && (
                <CSSWidgetTitle>
                    <JRCHtml __html={widgetWrapper.title ?? ''} />
                </CSSWidgetTitle>
            )}
        </>
    );
};
